import React, { Component } from 'react'
import { Tooltip as ReactTooltip } from 'react-tooltip'

class ActivityTab extends Component {
  state = {}
  render() {
    return (
      <>
        <ReactTooltip className='testPurple' id='activityTab-tooltip'/>
        <ul className='nav nav-tabs nav-tabs2' id='myTab' role='tablist'>
          <li className='nav-item' role='presentation'>
            <a
              className={
                this.props.tab === 'messages' ? 'nav-link active' : 'nav-link'
              }
              id='home-tab'
              data-toggle='tab'
              role='tab'
              href='#'
              aria-controls='messages'
              aria-selected='true'
              onClick={e => this.props.setTab('messages', e)}>
              {this.props.showUnreadDot && (
                <span className="notification-dot"></span>
              )}
              <i className="fa-solid fa-message-dots fa-lg mr-1" style={{ color: "#673ab7" }}></i>
              <b>Messages</b>
              <span>Messages</span>
              <i
              data-tooltip-id='activityTab-tooltip'
                data-tooltip-content='You can message your experts for up to 3 days after every appointment.'
                class='fas fa-info-circle ml-2'
                aria-hidden='true'
                style={{ color: 'rgb(24 0 88 / 50%)', fontSize: '12px' }}></i>
            </a>
          </li>
          <li className='nav-item' role='presentation'>
            <a
              className={
                this.props.tab === 'notes' ? 'nav-link active' : 'nav-link'
              }
              id='notes-tab'
              data-toggle='tab'
              role='tab'
              href='#'
              aria-controls='notes'
              aria-selected='false'
              onClick={e => this.props.setTab('notes', e)}>
              <i className="fa-solid fa-thought-bubble fa-lg mr-1" style={{ color: "#673ab7" }}></i>
              <b>Notes & Thoughts</b>
              <span>Notes & Thoughts</span>
            </a>
          </li>
          <li className='nav-item' role='presentation'>
            <a
              className={
                this.props.tab === 'tasks' ? 'nav-link active' : 'nav-link'
              }
              id='tasks-tab'
              data-toggle='tab'
              onClick={e => this.props.setTab('tasks', e)}
              role='tab'
              href='#'
              aria-controls='tasks'
              aria-selected='false'>
              <i className="fa-sharp-duotone fa-list-check fa-lg mr-1" style={{ "--fa-primary-color": "#673ab7", "--fa-secondary-color": "#673ab7" }}></i>  
              <b>Tasks</b>
              <span>Tasks</span>
              <i
              data-tooltip-id='activityTab-tooltip'
                data-tooltip-content='When task is allotted by your expert it will be visible here till  
                Completed and submitted. Find completed tasks under timeline.'
                class='fas fa-info-circle ml-2'
                aria-hidden='true'
                style={{ color: 'rgb(24 0 88 / 50%)', fontSize: '12px' }}></i>
            </a>
          </li>
          <li className='nav-item' role='presentation'>
            <a
              className={
                this.props.tab === 'documents' ? 'nav-link active' : 'nav-link'
              }
              id='documents-tab'
              data-toggle='tab'
              onClick={e => this.props.setTab('documents', e)}
              role='tab'
              href='#'
              aria-controls='documents'
              aria-selected='false'>
              <i className="fa-thumbprint fa-light fa-file fa-lg mr-1" style={{ "--fa-primary-color": "#673ab7", "--fa-secondary-color": "#673ab7" }}></i>
              <b>Documents</b>
              <span>Documents</span>
              <i
              data-tooltip-id='activityTab-tooltip'
                data-tooltip-content='Reports/ Past prescriptions can be shared from here with your                                                                                          
                experts.'
                class='fas fa-info-circle ml-2'
                aria-hidden='true'
                style={{ color: 'rgb(24 0 88 / 50%)', fontSize: '12px' }}></i>
            </a>
          </li>
        </ul>
      </>
    )
  }
}

export default ActivityTab
